import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Scenario } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: Scenario }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerScenarios,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
